import { onBiometricStatus } from "core/javascriptChannels";
import { useEffect, useState } from "react";

export enum BiometricStatus {
  unavailable = 1,
  enabled = 2,
  disabled = 3,
}

export const useBiometricStatus = (triggerReload?: boolean) => {
  const [status, setStatus] = useState<BiometricStatus>();
  const [loading, setLoading] = useState<boolean>();

  const getBiometricStatus = async () => {
    setLoading(true);
    try {
      const biometricStatus = await onBiometricStatus();
      setStatus(biometricStatus);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBiometricStatus();
  }, []);

  useEffect(() => {
    if (triggerReload) {
      getBiometricStatus();
    }
  }, [triggerReload]);

  return { status, loading };
};
